import { useState, useLayoutEffect, useMemo, useCallback } from 'react';
import _throttle from 'lodash/throttle';

export default function useScrollPosition() {
  const [scroll, setScroll] = useState({
    x: window.pageXOffset,
    y: window.pageYOffset,
    direction: '',
  });

  const listener = useCallback(() => {
    setScroll(prev => ({
      x: window.pageXOffset,
      y: window.pageYOffset,
      direction: prev.y < window.pageYOffset && prev.y >= 0 ? 'down' : 'up',
    }));
  }, []);

  const throttleFn = useMemo(() => _throttle(listener, 300), [listener]);

  useLayoutEffect(() => {
    window.addEventListener('scroll', throttleFn);
    // cleanup function occurs on unmount
    return () => window.removeEventListener('scroll', throttleFn);
  }, [throttleFn]); // Run `useEffect` only once on mount

  return scroll;
}



// WEBPACK FOOTER //
// ./src/lib/hooks/useScrollPosition.js